import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import stylesPc from "./UploadSlideStock.module.css";
import stylesSp from "./UploadSlideStock_SP.module.css";
import { IsDevice } from "../../components/function/useDeviceFlag";
import SlideStockInfoDetail from "./slideStocks/SlideStockInfoDetail";
import { DetailInfo } from "./slideStocks/DetailInfo";
import { Chapter, Tip } from "../../models/slides";
import { CreateNewSlide, GetTempPageCount } from "../../store/actions/SlideActions";
import { AppState } from "../../root/RootReducer";
import { Group } from "../../user/User";
import { useInitFlag } from "../../components/function/useInitFlag";
import PuiMessage from "../../components/widgets/PuiMessage";
import { GetGroupList, GetUserInfoList } from "../../user/UserActions";
import PuiFloatButton from "../../components/elements/PuiFloatButton";
import { GetTagIdFromTagName } from "../../utils/ObjectUtils";

interface UploadSlideStockProps {
    setIsSaved: (isSaved: boolean) => void;
    isSaved: boolean;
}

// const defaultGroup: Group[] = [
//     {
//         id: "1",
//         title: "pactera",
//         documentIds: [],
//         description: "pactera group",
//         userList: [],
//         videoList: []
//     }
// ];

function UploadSlideStock({ setIsSaved, isSaved }: UploadSlideStockProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const dispatch = useDispatch();

    const { tempFile, tempFilePageCount, isSuccessGetTempFilePageCount, isLoading, tags } =
        useSelector((state: AppState) => ({
            tempFile: state.slide.tempFile,
            tempFilePageCount: state.slide.tempFilePageCount,
            isSuccessGetTempFilePageCount: state.slide.isSuccessGetTempFilePageCount,
            isLoading: state.slide.isLoading,
            tags: state.video.tags,
        }));

    // コンテンツアップロード情報表示か、スライド・チャプター・補足情報表示かのた、変数定義
    const [visibleDetailInfoPage, ShowDetailInfoPage] = useState(true);

    // コンテンツアップロード
    const [inputSlideFile, InputSlideFile] = useState(null);
    const [inputSlideName, InputSlideName] = useState("");
    // コンテンツアップロードテキスト
    const [textUploadSlide, ChangeTextUploadSlide] =
        useState("アップロードするファイルを選択（50MBまで）");

    // プロフェッショナル
    const [inputSlideProfessional, InputSlideProfessional] = useState(-1);

    // コンテンツ要約
    const [inputSlideDetail, InputSlideDetail] = useState("");

    // 資料アップロード
    const [inputDocumentList, ChangeDocumentList] = useState<File[]>([]);
    const [inputDocumentNameList, ChangeDocumentNameList] = useState<string[]>([]);

    // コンテンツタイトル入力
    const [isErrorTitleValidation, CheckTitleValidation] = useState(false);

    // コンテンツ要約入力
    const [isErrorDescriptionValidation, CheckDescriptionValidation] = useState(false);

    // タグ選択モーダル画面
    const [tagList, setTagList] = useState<string[]>([]);

    // グループ
    // const [group, setGroup] = useState<Group[]>(defaultGroup);
    const [group, setGroup] = useState<Group[]>([]);

    // Chapter一覧の設定
    const [chapterList, setChapterList] = useState<Chapter[]>([]);

    // Tip一覧の設定
    const [tipList, setTipList] = useState<Tip[]>([]);

    // tempFilePageCountが-1の場合のメッセージ表示フラグ
    const [isTempFilePageCountError, setIsTempFilePageCountError] = useInitFlag(false);

    //【詳細情報入力】ボタン押下
    const detailInfoButton = () => {
        ShowDetailInfoPage(false);
    };

    // 完了ボタン押下
    const completeButton = () => {
        ShowDetailInfoPage(true);
    };

    // APIコール
    useEffect(() => {
        dispatch(GetUserInfoList());
        dispatch(GetGroupList());
    }, [dispatch]);

    // GetTempPageCount API CALL
    useEffect(() => {
        let timerGetTempPageCount: NodeJS.Timeout;
        if (tempFile.keyName !== "" && isSuccessGetTempFilePageCount) {
            if (tempFilePageCount === 0) {
                timerGetTempPageCount = setTimeout(
                    () => dispatch(GetTempPageCount(tempFile.keyName)),
                    3000
                );
            } else if (tempFilePageCount === -1) {
                setIsTempFilePageCountError(true);
            }
        }

        // クリーンアップ
        return () => {
            clearTimeout(timerGetTempPageCount);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tempFile.keyName, isSuccessGetTempFilePageCount]);
    const handleCloseInputError = () => {
        setIsTempFilePageCountError(false);
    };

    // 登録ボタンの有無効制御
    const [isReadyToUpdate, ChangeReadyToSendFlag] = useState(false);
    useEffect(() => {
        if (tempFilePageCount < 1) {
            ChangeReadyToSendFlag(true);
        } else {
            if (
                tempFile.keyName !== "" &&
                !isSaved &&
                inputSlideName !== "" &&
                inputSlideDetail !== "" &&
                inputSlideProfessional !== -1 &&
                inputSlideFile !== null &&
                !isErrorTitleValidation &&
                !isErrorDescriptionValidation &&
                inputDocumentList.length < 6
            ) {
                ChangeReadyToSendFlag(false);
            } else {
                ChangeReadyToSendFlag(true);
            }
        }
    }, [
        tempFilePageCount,
        tempFile.keyName,
        isSaved,
        inputSlideName,
        inputSlideDetail,
        inputSlideProfessional,
        inputSlideFile,
        isErrorTitleValidation,
        isErrorDescriptionValidation,
        inputDocumentList,
    ]);

    // 入力内容をバックエンドに送信
    const UploadSlide = () => {
        dispatch(
            CreateNewSlide({
                documentFile: inputDocumentList,
                documentName: inputDocumentNameList,
                content: {
                    keyName: tempFile.keyName,
                    title: inputSlideName,
                    description: inputSlideDetail,
                    presenterId: inputSlideProfessional,
                    fileName: tempFile.fileName,
                    tags: GetTagIdFromTagName(tagList, tags),
                    group: group.map((item) => Number(item.id)),
                    chapter: chapterList,
                    tips: tipList,
                },
            })
        );
        // 入力内容リセット
        ResetSlideInput();
    };

    // コンテンツアップロード後、入力内容リセット
    const ResetSlideInput = () => {
        // コンテンツファイル
        InputSlideFile(null);
        // タイトル
        InputSlideName("");
        // プロフェッショナル
        InputSlideProfessional(-1);
        // 要約
        InputSlideDetail("");
        // 資料
        ChangeDocumentList([]);
        ChangeDocumentNameList([]);
        // タグ
        setTagList([]);
        // グループ
        // setGroup(defaultGroup);
        setGroup([]);
        // Indexリスト
        setChapterList([]);
        // 補足リスト
        setTipList([]);
        setIsSaved(true);
    };

    // 表示待機
    if (isLoading) {
        return (
            <div className={styles.noSlide}>
                <CircularProgress size={60} style={{ color: "var(--loading-bg)" }} />
            </div>
        );
    }

    return (
        <>
            <div className={styles.mainDiv}>
                {visibleDetailInfoPage ? (
                    <>
                        <div className={styles.contentDetailDiv}>
                            <SlideStockInfoDetail
                                setIsSaved={setIsSaved}
                                showDetailInfoBtn={tempFilePageCount >= 1 ? true : false}
                                inputSlideFile={inputSlideFile}
                                InputSlideFile={InputSlideFile}
                                textUploadSlide={textUploadSlide}
                                ChangeTextUploadSlide={ChangeTextUploadSlide}
                                inputSlideName={inputSlideName}
                                InputSlideName={InputSlideName}
                                inputSlideProfessional={inputSlideProfessional}
                                InputSlideProfessional={InputSlideProfessional}
                                inputSlideDetail={inputSlideDetail}
                                InputSlideDetail={InputSlideDetail}
                                isErrorTitleValidation={isErrorTitleValidation}
                                CheckTitleValidation={CheckTitleValidation}
                                isErrorDescriptionValidation={isErrorDescriptionValidation}
                                CheckDescriptionValidation={CheckDescriptionValidation}
                                ChangeDocumentList={ChangeDocumentList}
                                inputDocumentList={inputDocumentList}
                                ChangeDocumentNameList={ChangeDocumentNameList}
                                inputDocumentNameList={inputDocumentNameList}
                                tagList={tagList}
                                setTagList={setTagList}
                                handleDetailInfoBtn={detailInfoButton}
                                group={group}
                                setGroup={setGroup}
                            />
                        </div>
                        <div className={styles.btnDiv}>
                            <PuiFloatButton
                                children={["　登録　"]}
                                size="medium"
                                isActive={!isReadyToUpdate}
                                color="secondary"
                                onClick={UploadSlide}
                            />
                        </div>
                    </>
                ) : (
                    <>
                        <DetailInfo
                            setIsSaved={setIsSaved}
                            chapterLists={chapterList}
                            setChapterList={setChapterList}
                            tipLists={tipList}
                            setTipList={setTipList}
                            editFlg={false}
                        />
                        <div className={styles.btnDiv}>
                            <PuiFloatButton
                                children={["　完了　"]}
                                size="medium"
                                color="secondary"
                                onClick={completeButton}
                            />
                        </div>
                    </>
                )}
            </div>
            <PuiMessage
                open={isTempFilePageCountError}
                type="error"
                title={
                    "ファイルの解析に失敗しました。再度アップロードするか、別のファイルをアップロードしてください"
                }
                onClose={handleCloseInputError}
            />
        </>
    );
}

export default UploadSlideStock;
